import React, { useState } from 'react';

import IconSave from '../assets/images/common/icon-save.svg';

import { STARTUP_API_ERRORS } from '../types/api/StartApiType';
import { ESTIMATE_API_ERRORS } from '../types/api/EstimateApiType';
import { EstimateInquiry } from '../types/common/EstimateInquiryType';
import { ErrorMessages } from '../types/common/Messages';

import { TemporarilySavedModal } from '../pages/Modals/TemporarilySavedModal';
import { EditEstimateRowLogic } from '../pages/EditEstimate/editEstimateRowLogic';
import { ErrorModalModal } from '../components/ErrorModal';
import { estimateApi } from '../api/estimate';
import { useAppDispatch } from '../store/hooks';

type TempSaveButtonProps = {
    clientId?: string;
    estimateInquiry: EstimateInquiry;
    tempSaveType: string;
};

// 一時保存ボタン
export const TempSaveButton: React.FC<TempSaveButtonProps> = ({
    clientId = '',
    estimateInquiry,
    tempSaveType,
}) => {
    // 一時保存ID管理
    const [draftId, setDraftId] = useState<string>('');
    // 一時保存 モーダル開閉管理
    const [openTempModal, setOpenTempModal] = useState<boolean>(false);
    // ボタン実行管理
    const [buttonPush, setButtonPush] = useState<boolean>(false);
    const dispatch = useAppDispatch();
    // バリデーションエラーメッセージ管理
    const [tempSaveMessage, setTempSaveMessage] = useState<Array<string>>([]);
    // バリデーションエラー モーダル管理
    const [openTempSaveErrorModal, setOpenTempSaveErrorModal] = useState<boolean>(false);

    // 一時保存ボタンアクション
    const tempSaveButton = () => {
        if (!buttonPush) {
            setButtonPush(true);
            // バリデーション
            const validationResult = EditEstimateRowLogic.validateEstimation(estimateInquiry, true, tempSaveType);
            if (validationResult.length > 0) {
                setTempSaveMessage(validationResult);
                setButtonPush(false);
                setOpenTempSaveErrorModal(true);
            } else {
                // チェックに成功
                const doTempSave = async () => {
                    const apiResult = await estimateApi.saveEstimate(
                        estimateInquiry,
                        dispatch,
                        clientId,
                        setDraftId,
                        true
                    );

                    // エラーハンドリング
                    if (apiResult.includes(STARTUP_API_ERRORS.REQUEST_ERROR_8001)) {
                        // 初期処理APIでエラーの場合
                        setTempSaveMessage([ErrorMessages.API8001_INIT_ERROR.replace('%1', apiResult)]);
                        setOpenTempSaveErrorModal(true);
                    } else if (apiResult.includes(ESTIMATE_API_ERRORS.REQUEST_ERROR_5002)) {
                        // 一時保存APIでエラーの場合
                        setTempSaveMessage([ErrorMessages.API5002_VALD_ERROR.replace('%1', apiResult)]);
                        setOpenTempSaveErrorModal(true);
                    } else {
                        // apiResultがエラー文言以外の場合、正常と判断
                        setOpenTempModal(true);
                    }
                    setButtonPush(false);
                };
                void doTempSave();
            }
        }
    };

    return (
        <>
            <TemporarilySavedModal openState={openTempModal} setOpenState={setOpenTempModal} draftId={draftId} tempSaveType={tempSaveType} />
            <a className='button js-modal-trigger' data-target='modal-save' onClick={tempSaveButton}>
                一時保存する
                <span className='icon is-small'>
                    <img src={IconSave} alt='' />
                </span>
            </a>
            <ErrorModalModal
                openState={openTempSaveErrorModal}
                setOpenState={setOpenTempSaveErrorModal}
                errorMessages={tempSaveMessage}
            />
        </>
    );
};
